import React from 'react'
import Sidebar from '../layouts/sidebar'
import Header from '../layouts/header'
import Layout from '../layouts/layout'
import PageHeading from '../layouts/pageHeading'
import AddTemplateTable from '../common/AddTemplateTable'
import MauvelousPrimaryButton from '../common/button/mauvelousPrimaryButton';
import { useNavigate,NavLink,useSearchParams } from 'react-router-dom'
import Cookies from "js-cookie";
import { API_URL } from '../utils/constants'
import axios from 'axios'
import { MdKeyboardArrowDown } from 'react-icons/md';
import { cssProperties } from '../utils/commonCssProperties';
import { Link as MuiLink, Typography } from '@mui/material';
import Index from "../components/TemplateManagemanet/index";


const AddTemplate = () => {

 const [searchParams] = useSearchParams();
   const page = searchParams.get("page");
   const naviagte = useNavigate();
 
   const handleClick = () => {
     if (page === "addtemplate" || page === "updatetemplate" || page === "createtemplate") {
       naviagte(`/${Cookies.get("mhet_mst_project")}/add-template?page=templatelist`);
     }
   };
 
   const breadcrumbs = [
     <MuiLink
       underline="hover"
       key="1"
       component={NavLink}
       to={`/${Cookies.get("mhet_mst_project")}/home`}
       sx={{
         color: cssProperties?.fontcolor?.primary,
         fontSize: "14px",
         fontWeight: 400,
         lineHeight: "20px",
         letterSpacing: "0.1px",
       }}
     >
       Dashboard
     </MuiLink>,
     <Typography
       key="3"
       color="text.primary"
       sx={{
         display: "flex",
         alignItems: "center",
         gap: "12px",
         color: cssProperties?.fontcolor?.primary,
         fontSize: "14px",
         fontWeight: page === "templatelist"  ? "bold" : 400,
         lineHeight: "20px",
         letterSpacing: "0.1px",
         ":hover":{
           textDecoration: page === "templatelist" ? "none" : "underline",
           cursor : page === "templatelist" ? "none" : "pointer"
         }
       }}
       onClick={page === "templatelist" ? undefined : handleClick}
     >
       Template Management {page === "templatelist" && <MdKeyboardArrowDown size={16} /> }
     </Typography>,
   ];
 
   if (page === "addtemplate") {
     breadcrumbs.push(
       <Typography
         key="2"
         color="text.primary"
         sx={{
           display: "flex",
           alignItems: "center",
           gap: "12px",
           color: cssProperties?.fontcolor?.primary,
           fontSize: "14px",
           fontWeight: "bold",
           lineHeight: "20px",
           letterSpacing: "0.1px",
         }}
       >
         Add Template<MdKeyboardArrowDown size={16} />
       </Typography>
     );
   }else if (page === "updatetemplate"){
     breadcrumbs.push(
       <Typography
         key="2"
         color="text.primary"
         sx={{
           display: "flex",
           alignItems: "center",
           gap: "12px",
           color: cssProperties?.fontcolor?.primary,
           fontSize: "14px",
           fontWeight: "bold",
           lineHeight: "20px",
           letterSpacing: "0.1px",
         }}
       >
         Update Template<MdKeyboardArrowDown size={16} />
       </Typography>
     );
   }else if (page === "createtemplate"){
     breadcrumbs.push(
       <Typography
         key="2"
         color="text.primary"
         sx={{
           display: "flex",
           alignItems: "center",
           gap: "12px",
           color: cssProperties?.fontcolor?.primary,
           fontSize: "14px",
           fontWeight: "bold",
           lineHeight: "20px",
           letterSpacing: "0.1px",
         }}
       >
         Create Template<MdKeyboardArrowDown size={16} />
       </Typography>
     );
   }else if(page ==="previewtemplate"){
    breadcrumbs.push(
      <Typography
        key="2"
        color="text.primary"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          color: cssProperties?.fontcolor?.primary,
          fontSize: "14px",
          fontWeight: "bold",
          lineHeight: "20px",
          letterSpacing: "0.1px",
        }}
      >
        Preview Template<MdKeyboardArrowDown size={16} />
      </Typography>
    )
   }

   
  return (
    <>
           <Header breadcrumbs={breadcrumbs}/>
           <Sidebar />
           <Layout>
             <PageHeading
               title={
                 page === "templatelist"
                   ? "Template Management"
                   : page === "addtemplate"
                   ? "Add Template"
                   : page === "updatetemplate"
                   ? "Update Template"
                   : page === "createtemplate"
                   ? "Create Template"
                   : page === "previewtemplate"
                   ? "Preview Template"
                   : null
               }
             />
             <Index />
           </Layout>
        
    </>
  )
}

export default AddTemplate
